import React, { useState, useEffect } from "react";

const FilterByRoleModal = ({ users, appliedRoles, onApply, onClose }) => {
  const [selectedRoles, setSelectedRoles] = useState(appliedRoles || []);

  // Extract unique role names
  const uniqueRoles = Array.from(
    new Set(users.map((u) => (u.rolename || "").trim()))
  ).filter(Boolean);

  const toggleRole = (role) => {
    setSelectedRoles((prev) =>
      prev.includes(role)
        ? prev.filter((r) => r !== role)
        : [...prev, role]
    );
  };

  const clearAll = () => setSelectedRoles([]);

  const applyFilters = () => {
    onApply(selectedRoles);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[1000]">
<div className="bg-white p-6 rounded-xl w-[600px] shadow-xl">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Filter by Role</h2>
          <button onClick={onClose}   className="text-black text-3xl outline-none focus:outline-none focus:ring-0">×</button>
        </div>

        {/* ROLES GRID */}
        <div className="flex flex-row flex-wrap gap-2 mb-5">
          {uniqueRoles.map((role, index) => (
            <button
              key={index}
              onClick={() => toggleRole(role)}
              className={`rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-0
                ${
                  selectedRoles.includes(role)
                    ? "bg-[#E17954] text-white"
                    : "bg-[#F3F4F6] text-black  "
                }`}
            >
              {role}
            </button>
          ))}
        </div>

        {/* FOOTER */}
        <div className="flex justify-between items-center">
          <button
            onClick={clearAll}
            className="text-gray-500 text-sm hover:underline"
          >
            Clear all
          </button>

          <button
            onClick={applyFilters}
            className="bg-black text-white px-6 py-2 rounded-lg text-sm"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterByRoleModal;
